var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-style-2"},[(_vm.data.showFooter)?_c('CallToAction',{attrs:{"style-type":8,"title":"","subtitle":"","btn-text":"Purchase Doob"}}):_vm._e(),(_vm.data.showCopyright)?_c('CopyrightTwo'):_vm._e(),_c('ScrollTop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }